import { render, staticRenderFns } from "./invoice-payment.vue?vue&type=template&id=38ec7c85"
import script from "./invoice-payment.vue?vue&type=script&lang=ts"
export * from "./invoice-payment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports